import { useEffect, useState } from "react";

export function usePublicList(url) {
  const [state, setState] = useState({
    items: [],
    loading: true,
    error: "",
  });

  useEffect(() => {
    const controller = new AbortController();

    setState({
      items: [],
      loading: true,
      error: "",
    });

    async function load() {
      try {
        const response = await fetch(url, {
          signal: controller.signal,
          cache: "no-store",
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Unable to load data.");
        }

        if (!Array.isArray(data)) {
          throw new Error("The server must return a JSON array.");
        }

        const items = data.map((item) => {
          const result = { ...item };

          for (const field of ["src", "thumbnail", "image"]) {
            if (typeof result[field] === "string" && result[field]) {
              result[field] = new URL(result[field], response.url).href;
            }
          }

          return result;
        });

        if (!controller.signal.aborted) {
          setState({
            items,
            loading: false,
            error: "",
          });
        }
      } catch (error) {
        if (controller.signal.aborted) return;

        setState({
          items: [],
          loading: false,
          error: error.message || "Unable to load data.",
        });
      }
    }

    load();

    return () => controller.abort();
  }, [url]);

  return state;
}
